import { faCode, faCube, faMobileAlt, faPalette } from '@fortawesome/free-solid-svg-icons';
import { Button, Section, Card,CheckText } from '../../components';
import photo from '../../assets/images/pp2.jpg'
import useStyles from './stylesheet';
import React from 'react';

const Resume = () => {
  const classes = useStyles();

  return <div className={classes.container} id="resume">
    <Section 
    title={'About'}
    border={true}
    background={true}
    >
      <div className={classes.datas}>
        <img src={photo} alt="" className={classes.img}/>
        <div className={classes.textArea}>
          <div className={classes.infos}>
            Full-Stack Developer specializing in React, React Native,
            and TypeScript, with 4 years of corporate and freelance experience. 
            I also leverage UI/UX and 3D design fundamentals to support visually consistent
            and user-focused interfaces.
          </div>
          <div className={classes.items}>
            <div className={classes.item} >
              <p className={classes.title}>Age:</p>
              <p>23</p>
            </div>
            <div className={classes.item} >
              <p className={classes.title}> Residence:</p>
              <p>Turkey</p>
            </div>
          </div>
          <div className={classes.items}>
            <div className={classes.item} >
              <p className={classes.title}>Freelance:</p>
              <p>Available</p>
            </div>
            <div className={classes.item} >
              <p className={classes.title}>Address:</p>
              <p>Konya</p>
            </div>
          </div>
          <div className={classes.items}>
            <div className={classes.item} >
              <p className={classes.title}>Phone:</p>
              <p>+90 551 137 81 55</p>
            </div>
            <div className={classes.item} >
              <p className={classes.title}>E-mail:</p>
              <p>business@mehmetaliselek.com</p>
            </div>
          </div>
          <Button 
          title='Download CV'
          onClick={() => {
            const link = document.createElement("a");
            link.href = "/assets/CV.pdf";
            link.download = "MehmetAliSelek_CV_en.pdf";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }}/>
        </div>
      </div>
    </Section>
    <Section
    title={'Services'}
    style={{border:'none'}}
    >
      <div className={classes.servicesCards}>
        <Card
        title={'Web Development'}
        description={'Modern and mobile-ready website that will help you reach all of your marketing.'}
        icon={faCode}
        />
        <Card
        title={'Mobile Application'}
        description={'Modern and user-friendly mobile apps for seamless experiences on any device.'}
        icon={faMobileAlt}
        />
      </div>
      <div className={classes.servicesCards}>
        <Card
        title={'Graphic Design'}
        description={'Creative and eye-catching designs that make your brand stand out.'}
        icon={faPalette}
        />
        <Card
        title={'3D Design'}
        description={'High-quality and detailed 3D designs for stunning visual experiences.'}
        icon={faCube}
        />
      </div>
    </Section>
    <div className={classes.experience}>
      <Section title={'Experience'}>
        <Card
        title={'NİBGAT® | Chief Marketing Officer'}
        description={'2025 December - 2026 February'}
        />
        <Card
        title={'NİBGAT® | Front-End Developer'}
        description={'2025 March - December '}
        />
        <Card
        title={'NİBGAT® | Community Head of Design'}
        description={'2024 February - Present'}
        />
        <Card
        title={'KOI Directorate/ Network and System Unit Intern'}
        description={'2023 / 2024 July(Total 3 Months)'}
        />
        <Card
        title={'Freelancer'}
        description={'2022 - Present'}
        />
      </Section>
      <Section title={'Education'}>
        <Card
        title={'Ataturk University'}
        description={"Graphic Design (Bachelor's Degree) 2025 - Present"}
        />
        <Card
        title={'Konya Technical University'}
        description={'Computer Science (Associate Degree) 2022-2024'}
        />
        <Card
        title={'Çaycore-Sıfırdan Geliştirici Olmak'}
        description={"I successfully completed the 'Sıfırdan Geliştirici Olmak' training series and earned a certificate."}
        />
      </Section>
    </div>
    <Section
    title={'Knowledge'}
    background={true}
    border={true}
    >
      <div className={classes.li}>
        <div className={classes.list}>
          <CheckText>
            Web Development
          </CheckText>
          <CheckText>
            Typescript
          </CheckText>
          <CheckText>
            Nest.js
          </CheckText>
          <CheckText>
            Node.js
          </CheckText>  
        </div>
        <div className={classes.list}>
          <CheckText>
            React / React Native
          </CheckText>
          <CheckText>
            Next.js
          </CheckText>
          <CheckText>
            3D Design
          </CheckText>
         <CheckText>
            UI/UX Design
          </CheckText> 
        </div>
      </div>
    </Section>
  </div>
}

export default Resume;
